import React from "react";
import styles from "./reusableFunctions.module.scss";

enum ImageSize {
  Thumb = 200,
  Medium = 620,
  Large = 1200,
}

const getSizedImageURL = (image: string, size: ImageSize = ImageSize.Thumb) => {
  const i = image.split(".");
  return i
    .map((t, key) => {
      if (key === i.length - 2) {
        return `${t}_${size}x${size}`;
      } else {
        return t;
      }
    })
    .join(".");
};

const SampleNextArrow = (props: any) => (
  <div onClick={props.onClick} className={styles.arrows}>
    <img src="/icons/next-1.svg" alt="<" />
  </div>
);
const SamplePrevArrow = (props: any) => (
  <div onClick={props.onClick} className={styles.arrows}>
    <img src="/icons/back.svg" alt=">" />
  </div>
);

const slickSettings = {
  className: "center",
  centerMode: true,
  centerPadding: "0px", // remove default 50px side padding so slides span full width
  variableWidth: true,     // let slides size themselves rather than forcing equal width
  adaptiveHeight: true,    // ensure slider height adapts to tallest slide
  slidesToShow: 4,
  slidesToScroll: 1,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      // mobile: only one slide and center mode turned off to avoid overlapping issues
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        centerMode: false,
        centerPadding: "0px",
      },
    },
  ],
};

export {
  getSizedImageURL,
  ImageSize,
  slickSettings,
  SampleNextArrow,
  SamplePrevArrow,
};
